import { Trans, useLingui } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { isCancelled } from '@/models/request';
import { useBrandOrAppRequestContext } from '@/utils/useBrandOrAppRequestContext';

import { ArticleCard } from '../../shared/ClientArticlesList/components/ArticleCard';
import { StepMessage } from '../../shared/StepMessage';

const Archived = () => {
  const { request } = useBrandOrAppRequestContext();
  const { t } = useLingui();

  return (
    <BrandRequestMainContent>
      <Stack gap="1rem">
        <StepMessage
          message={
            isCancelled(request) ? (
              <Trans id="client.request.cancelled.title">
                Your after-sales service request has been cancelled.
              </Trans>
            ) : (
              <Trans id="client.request.archived.title">
                Your after-sales service request has been archived.
              </Trans>
            )
          }
        />

        <Box padding="0" ariaLabel={t({ id: 'client.articles.table.label', message: 'Items' })}>
          {request.allArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </Box>
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Archived;
